"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Badge = _interopRequireDefault(require("angieslist-react-components/lib/Badge"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _hr, _hr2, _p;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var activityLocation = 'Ads Auth Header';

var AngiAdsLeftSideBarItems = function AngiAdsLeftSideBarItems(_ref) {
  var expandedSubNav = _ref.expandedSubNav,
      hasBmt = _ref.hasBmt,
      isAdmin = _ref.isAdmin,
      isAdvertiser = _ref.isAdvertiser,
      leadsNotificationCount = _ref.leadsNotificationCount,
      openSubNav = _ref.openSubNav,
      spId = _ref.spId,
      reviewsNotificationCount = _ref.reviewsNotificationCount,
      callTrackingFeatureFlag = _ref.callTrackingFeatureFlag;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 4,
    className: "side-menu-leads-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Leads",
    href: _urlCatalog["default"].office.ads.leadBoard(spId),
    id: "unified-header-sidebar-nav--leads"
  }, "Leads"))), leadsNotificationCount && leadsNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    bsStyle: "danger",
    className: "unified-header-sidebar-nav--notification unified-header-sidebar-nav--notification-leads",
    style: {
      marginLeft: '-14px'
    }
  }, leadsNotificationCount) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 8,
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Reviews",
    href: _urlCatalog["default"].office.ads.reviews(spId),
    id: "unified-header-sidebar-nav--reviews"
  }, "Reviews")), reviewsNotificationCount && reviewsNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    bsStyle: "danger",
    className: "unified-header-sidebar-nav--notification",
    style: {
      marginLeft: '-3px'
    }
  }, reviewsNotificationCount) : null), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "unified-header-sidebar-nav--divider-dropdown"
  }, _hr || (_hr = /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("i", {
    id: "unified-header-side-bar--sub-nav-reviews--dropdown",
    tabIndex: 0,
    role: "button",
    className: "icon ".concat(expandedSubNav === 'reviews' ? 'icon-up-open' : 'icon-down-open'),
    onClick: function onClick() {
      return openSubNav('reviews');
    },
    onKeyDown: function onKeyDown() {
      return openSubNav('reviews');
    }
  }))), expandedSubNav === 'reviews' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All reviews",
    href: _urlCatalog["default"].office.ads.reviews(spId),
    id: "unified-header-side-bar--sub-nav--all-reviews",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--first-sub-nav-item"
  }, "All reviews")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activiy-location": activityLocation,
    "data-track-description": "Request reviews",
    href: _urlCatalog["default"].office.ads.requestReviews(spId),
    id: "unified-header-side-bar--sub-nav--request-reviews",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--last-sub-nav-item"
  }, "Request reviews"))))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey margin-b-15"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 4,
    className: "side-menu-right-margin-full"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "My business",
    href: _urlCatalog["default"].office.ads.spProfile.edit(spId),
    id: "unified-header-sidebar-nav--myBusiness"
  }, "My business"))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "unified-header-sidebar-nav--divider-dropdown"
  }, _hr2 || (_hr2 = /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("i", {
    id: "unified-header-side-bar--sub-nav-my-business--dropdown",
    tabIndex: 0,
    role: "button",
    className: "icon ".concat(expandedSubNav === 'myBusiness' ? 'icon-up-open' : 'icon-down-open'),
    onClick: function onClick() {
      return openSubNav('myBusiness');
    },
    onKeyDown: function onKeyDown() {
      return openSubNav('myBusiness');
    }
  }))), expandedSubNav === 'myBusiness' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Settings",
    href: _urlCatalog["default"].office.ads.spProfile.edit(spId),
    id: "unified-header-side-bar--sub-nav--settings",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--first-sub-nav-item"
  }, "Business profile")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Coverage area",
    href: _urlCatalog["default"].office.ads.spProfile.serviceAreas(spId),
    id: "unified-header-side-bar--sub-nav--coverage-area",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Service areas")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Services",
    href: _urlCatalog["default"].office.ads.manageCategories(spId),
    id: "unified-header-side-bar--sub-nav--services",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Service categories")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Associates",
    href: _urlCatalog["default"].office.ads.associates(spId),
    id: "unified-header-side-bar--sub-nav--associates",
    className: "unified-header-side-bar--sub-nav-item ".concat(!hasBmt ? 'unified-header-side-bar--last-sub-nav-item' : '')
  }, "Associates")))), hasBmt ? [/*#__PURE__*/_react["default"].createElement(_Row["default"], {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Customers",
    href: _urlCatalog["default"].office.bmt.customers(spId),
    id: "unified-header-side-bar--sub-nav--customers",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Customers")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Price list",
    href: _urlCatalog["default"].office.bmt.priceList(spId),
    id: "unified-header-side-bar--sub-nav--price-list",
    className: "unified-header-side-bar--sub-nav-item ".concat(!isAdmin || !isAdvertiser ? 'unified-header-side-bar--last-sub-nav-item' : '')
  }, "Price list"))))] : null, isAdmin && isAdvertiser ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage agreements",
    href: _urlCatalog["default"].office.ads.paymentMethod(spId),
    id: "unified-header-side-bar--sub-nav--agreements",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--last-sub-nav-item"
  }, "Manage agreements")))) : null, callTrackingFeatureFlag ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Connected numbers",
    href: _urlCatalog["default"].office.ads.connectedNumbers(spId),
    id: "unified-header-side-bar--sub-nav--connected-numbers",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--last-sub-nav-item"
  }, "Connected numbers")))) : null) : null), /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header-side-bar--sub-nav-download-wrapper"
  }, _p || (_p = /*#__PURE__*/_react["default"].createElement("p", {
    id: "unified-header-side-bar--sub-nav-text"
  }, "Download the app to manage your leads on the go")), /*#__PURE__*/_react["default"].createElement("a", {
    id: "unified-header-side-bar--sub-nav-btn",
    href: _urlCatalog["default"].office.download()
  }, "Download now")));
};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)), _pure["default"])(AngiAdsLeftSideBarItems);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/angiAdsLeftSideBarItems.js
// module id = 3563
// module chunks = 25